<button
  class="ui-btn"
  [ngClass]="'ui-btn--' + variant"
  [disabled]="disabled"
  [type]="type"
  (click)="onClick($event)">
  <mat-icon *ngIf="icon" class="ui-btn__icon">{{ icon }}</mat-icon>
  <span *ngIf="label">{{ label }}</span>
</button>
